// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer24CircleFilled: FC<FastTimer24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="m22.7 18.3-1.425 1.425-3.275-3.3V12h2v3.6l2.7 2.7Z" />
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-2.675-10.325C14.875 23.225 16.767 24 19 24c2.217 0 4.104-.775 5.663-2.325C26.22 20.125 27 18.233 27 16c0-2.217-.78-4.104-2.337-5.662C23.104 8.779 21.216 8 19 8c-2.233 0-4.125.78-5.675 2.338C11.775 11.896 11 13.783 11 16c0 2.233.775 4.125 2.325 5.675ZM6 11v2h4v-2H6Zm4 4H5v2h5v-2Zm-4 4v2h4v-2H6Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default FastTimer24CircleFilled;
